import { CreditList } from './list';

/**
 * Page shell for /app/credit, in the same shape as pages/cash-drawer/index.tsx (a component plus
 * named re-exports). Unlike cash-drawer there is no create action here: a credit account is never
 * created from this screen — it appears the first time a customer is sold to on credit, or the
 * first time they open their own account in the storefront.
 */
export const CreditPage = () => <CreditList />;

export { CreditList } from './list';
export { CreditShow } from './show';
export { default as RecordPaymentModal } from './components/RecordPaymentModal';
export { default as SetCreditLimitModal } from './components/SetCreditLimitModal';

export default CreditPage;
